/* ============================================================
   NeoSpherium · recently-viewed rail ("Where you have been").
   Device-local only (localStorage), same pattern as ns-wishlist.js. On a PDP it records a
   small snapshot of the current product; on any page that contains the rail container it
   renders up to SHOW pieces (most-recent first, current product excluded). No fetches, no
   scarcity, no cross-device tracking. Fails silent if localStorage is unavailable.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'ns-recently-viewed';
  var MAX = 12;   /* how many we remember */
  var SHOW = 4;   /* how many the rail renders (matches the .edit__grid 4-up) */

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  /* --- record the current product, if this is a PDP --- */
  var currentHandle = null;
  var blob = document.querySelector('[data-ns-rv-current]');
  if (blob) {
    try {
      var p = JSON.parse(blob.textContent);
      if (p && p.handle) {
        currentHandle = p.handle;
        var list = read().filter(function (x) { return x && x.handle !== p.handle; });
        list.unshift(p);
        if (list.length > MAX) list = list.slice(0, MAX);
        write(list);
      }
    } catch (e) {}
  }

  /* --- render the rail, if a container is present (homepage) --- */
  var sec = document.querySelector('[data-ns-rv]');
  if (!sec) return;
  var grid = sec.querySelector('[data-ns-rv-grid]');
  if (!grid) return;

  var items = read().filter(function (x) { return x && x.handle && x.handle !== currentHandle; }).slice(0, SHOW);
  if (!items.length) return;   /* nothing yet → stays hidden, no empty state */

  var frag = document.createDocumentFragment();
  items.forEach(function (it) {
    var a = document.createElement('a');
    a.href = it.url || '#';
    a.className = 'edit__tile';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'edit__img';
    if (it.image) {
      var img = document.createElement('img');
      img.src = it.image;
      img.alt = it.title || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      imgWrap.appendChild(img);
    }
    a.appendChild(imgWrap);

    if (it.vendor) {
      var brand = document.createElement('span');
      brand.className = 'edit__brand';
      brand.textContent = String(it.vendor).toUpperCase();
      a.appendChild(brand);
    }

    var title = document.createElement('p');
    title.className = 'edit__title';
    title.textContent = it.title || '';
    a.appendChild(title);

    if (it.price) {
      var price = document.createElement('span');
      price.className = 'edit__price';
      price.textContent = it.price;
      a.appendChild(price);
    }

    frag.appendChild(a);
  });

  grid.appendChild(frag);
  sec.hidden = false;
})();
